import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchFundraiserDonations } from '@client/connectivity/api.donation';

export const DONATION_REDUCER_KEY = 'donationReducer';
export const LOAD_FUNDRAISER_DONATIONS = 'LOAD_FUNDRAISER_DONATIONS';
export const SET_DONATION_ERROR = 'SET_DONATION_ERROR';
export const SET_DONATION_IN_PROGRESS = 'SET_DONATION_IN_PROGRESS';

let defaultState = fromJS({
  donation: [],
  donationInProgress: false,
  errors: {
    loadFundraisers: null,
  },
});

export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_FUNDRAISER_DONATIONS: {
      const errors = state.get('errors');
      return state.merge({
        donation: fromJS(action.payload),
        errors: errors.set('loadFundraiserDonations', null),
      });
    }
    case SET_DONATION_IN_PROGRESS: {
      return state.set('donationInProgress', action.payload);
    }
    default:
      return state;
  }
}

export function loadFundraiserDonations(fundraiserSlug) {
  return function(dispatch) {
    return fetchFundraiserDonations(fundraiserSlug)
      .then((response) => {
        return dispatch({
          type: LOAD_FUNDRAISER_DONATIONS,
          payload: response.data,
        });
      })
      .catch((error) => {
        return setErrorMessage(dispatch, error);
      });
  };
}

export function setMakeDonationInProgress(inProgress) {
  return {
    type: SET_DONATION_IN_PROGRESS,
    payload: inProgress,
  };
}

function setErrorMessage(dispatch, error) {
  return dispatch({
    type: SET_DONATION_ERROR,
    payload: error,
  });
}

export const selectDonationList = (state) => {
  return getIn(state[DONATION_REDUCER_KEY], 'donation');
};

export const selectDonationInProgress = (state) => {
  return getIn(state[DONATION_REDUCER_KEY], 'donationInProgress');
};
